import { Alert } from "@fluentui/react-northstar";
import React from "react";

const AssistanceAlert = (props) => {
  const { dismissAlert } = props;

  return (
    <Alert
      data-testid="assistanceAlert"
      content="Assistance Requested"
      dismissible
      dismissAction={{
        onClick: dismissAlert,
      }}
    />
  );
};

export default AssistanceAlert;
